var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningRafiki1 = function SvgWarningRafiki1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 111,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#warning-rafiki-1_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E7E8E9",
    d: "M140 92.072H0v.07h140zM125.972 96.577h-9.274v.07h9.274zM92.742 97.339h-2.433v.07h2.433zM116.419 93.979h-5.374v.07h5.374zM26.782 94.45H14.69v.07h12.093zM31.05 94.45h-1.773v.07h1.772zM63.042 95.63h-26.23v.07h26.23zM66.36 79.584H12.295a1.6 1.6 0 0 1-1.596-1.599v-76A1.6 1.6 0 0 1 12.295.4H66.36a1.6 1.6 0 0 1 1.599 1.599v75.986a1.6 1.6 0 0 1-1.6 1.599M12.295.456a1.53 1.53 0 0 0-1.526 1.529v76a1.53 1.53 0 0 0 1.526 1.529H66.36a1.53 1.53 0 0 0 1.529-1.529v-76a1.53 1.53 0 0 0-1.53-1.53zM126.927 79.584H72.859a1.6 1.6 0 0 1-1.6-1.599v-76A1.6 1.6 0 0 1 72.86.4h54.068a1.6 1.6 0 0 1 1.593 1.585v76a1.6 1.6 0 0 1-1.593 1.599M72.859.456a1.53 1.53 0 0 0-1.53 1.529v76a1.53 1.53 0 0 0 1.53 1.529h54.068a1.53 1.53 0 0 0 1.528-1.529v-76a1.53 1.53 0 0 0-1.528-1.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E8E9",
    d: "M110.063 6.325H28.361V44.55h81.702z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M111.291 6.325H28.935V44.55h82.356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E8E9",
    d: "M110.063 44.55H28.361v1.95h81.702z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M113.341 44.55H30.985v1.95h82.356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F8",
    d: "M109.57 42.828V8.05H30.66v34.778z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.125 42.828 43.92 8.05h7.484L46.61 42.828z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M31.455 41.112a.123.123 0 0 1-.123-.123V9.169a.123.123 0 0 1 .246 0V41a.12.12 0 0 1-.123.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.216 42.828 53.012 8.05h2.918l-4.797 34.778z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E8E9",
    d: "M109.57 42.828V8.05h-.219v34.778z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E8E9",
    d: "M111.698 10.648H29.999l-.16-1.93h81.702zM111.698 13.81H29.999l-.16-1.93h81.702zM111.698 16.973H29.999l-.16-1.93h81.702zM111.698 20.134H29.999l-.16-1.929h81.702zM111.698 23.298H29.999l-.16-1.929h81.702zM111.698 26.46H29.999l-.16-1.93h81.702z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E8E9",
    d: "M122.92 54.16h-12.468v37.912h12.468z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F8",
    d: "M119.591 92.072h3.329v-5.233h-6.821z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E8E9",
    d: "M88.925 54.16H76.457v37.912h12.468z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F8",
    d: "M122.92 54.16H86.019v36.112h36.901z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F8",
    d: "M89.348 92.072h-3.33v-5.233h6.821z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M120.336 67.617H88.601v9.035h31.735zM120.336 78.584H88.601v9.036h31.735z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F8",
    d: "M93.587 66.833h21.773v.44a1.31 1.31 0 0 1-1.307 1.307H94.898a1.31 1.31 0 0 1-1.308-1.308v-.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M120.336 56.646H88.601v9.036h31.735z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F8",
    d: "M93.587 55.865h21.773v.44a1.31 1.31 0 0 1-1.307 1.307H94.898a1.31 1.31 0 0 1-1.308-1.307v-.44zM93.587 77.8h21.773v.44a1.31 1.31 0 0 1-1.307 1.308H94.898a1.31 1.31 0 0 1-1.308-1.308v-.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E8E9",
    d: "M14.958 62.244c.694-1.997 6.16.716 8.4 4.02 1.48 2.201 2.385 4.55 2.8 7.706-.05-3.6-.107-7.468-.163-11.119-.45-.91-1.478-3.01-2.215-4.673-2.464-5.55-8.321-7.616-10.36-11.119-2.651-4.592-2.634-11.48-.378-13.96 1.96-2.162 8.456 12.44 9.19 14.072 2.52 5.6 3.248 9.775 3.718 13.81-.053-3.43-.103-6.578-.145-9.008-.137-7.924-.311-10.472-.39-11.256-.28-.383-.59-.84-.778-1.07-1.57-2.024-5.06-4.432-6.801-7.375-2.545-4.295-2.134-9.436-.35-11.35 1.881-2.003 5.194 2.718 6.933 7.416s1.002 9.173 1.495 13.068c.103.761.207 3.662.308 7.686.532-4.329 1.59-7.23 3.55-9.932 2.414-3.323 4.497-7.37 6.485-6.846s.919 5.88-.655 9.638c-1.4 3.346-8.31 6.686-9.33 9.377.12 5.454.227 12.362.306 18.794.543-3.324.168-3.601 2.402-8.68 1.327-3.024 6.768-6.751 7.417-4.673.65 2.077-.339 6.003-2.391 8.752-1.658 2.22-5.32 2.218-6.185 3.593-.2.322-.84 1.554-1.23 2.26.087 7.853.13 14.783.084 17.147l-.358.025c.02-.61-.025-4.606-.095-9.893-.893-2.8-6.902-4.452-8.759-7.378-1.943-3.068-3.34-6.641-2.506-9.032"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M20.608 92.072h11.536a1.33 1.33 0 0 0 1.3-1.061l.817-4.038H18.48l.84 4.038a1.33 1.33 0 0 0 1.288 1.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M18.16 88.538h16.431a.776.776 0 0 0 .77-.688l.336-2.985a.777.777 0 0 0-.77-.86H17.825a.776.776 0 0 0-.77.86l.336 2.985a.775.775 0 0 0 .77.688"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E8E9",
    d: "M49.795 73.934h-9.858v18.138h9.858z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E8E9",
    d: "M74.922 92.072H41.913l-3.47-24.612h33.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M79.739 92.072H43.224L39.757 67.46H76.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m46.796 88.225-2.92-16.918h28.82l2.92 16.918z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F8",
    d: "m59.18 88.225-9.794-16.918h3.072l9.797 16.918zM63.557 88.225 53.76 71.307H59l9.795 16.918z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M70 104.717c29.983 0 54.289-1.419 54.289-3.17S99.983 98.377 70 98.377s-54.29 1.42-54.29 3.17 24.307 3.17 54.29 3.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E35B55",
    d: "M36.022 47.029a.12.12 0 0 1-.12-.11l-.622-7.476a.12.12 0 0 1 .107-.123.12.12 0 0 1 .129.11l.621 7.475a.12.12 0 0 1-.109.13zM36.392 51.47a.12.12 0 0 1-.12-.11l-.188-2.262a.12.12 0 0 1 .027-.088.12.12 0 0 1 .082-.04.12.12 0 0 1 .088.026.12.12 0 0 1 .041.082l.188 2.263a.12.12 0 0 1-.11.128z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M99.383 72.744H41.57a2.976 2.976 0 0 1-2.904-2.683l-3.256-39.14a2.435 2.435 0 0 1 2.458-2.683H95.68a2.98 2.98 0 0 1 2.906 2.682l3.257 39.136a2.442 2.442 0 0 1-2.459 2.688"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E35B55",
    d: "M99.383 72.856H41.57a3.08 3.08 0 0 1-3.016-2.783l-3.256-39.139a2.58 2.58 0 0 1 .664-1.974 2.55 2.55 0 0 1 1.906-.84H95.68a3.08 3.08 0 0 1 3.018 2.8l3.254 39.136a2.547 2.547 0 0 1-2.568 2.8m-61.516-44.5a2.324 2.324 0 0 0-2.349 2.564l3.257 39.133a2.86 2.86 0 0 0 2.8 2.579h57.808a2.326 2.326 0 0 0 2.347-2.56l-3.257-39.138a2.86 2.86 0 0 0-2.8-2.579z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E35B55",
    d: "M95.68 28.243H37.867a2.436 2.436 0 0 0-2.459 2.677h63.177a2.98 2.98 0 0 0-2.907-2.677"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.22 29.585a.523.523 0 0 1-.53.58.644.644 0 0 1-.626-.58.527.527 0 0 1 .529-.58.64.64 0 0 1 .627.58M41.572 29.585a.523.523 0 0 1-.529.58.644.644 0 0 1-.616-.58.527.527 0 0 1 .53-.58.64.64 0 0 1 .615.58M43.924 29.585a.523.523 0 0 1-.529.58.644.644 0 0 1-.627-.58.526.526 0 0 1 .529-.58.64.64 0 0 1 .627.58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M94.366 67.614h-48.62a2.366 2.366 0 0 1-2.31-2.13L41.153 38.2a1.938 1.938 0 0 1 1.96-2.13h48.627a2.366 2.366 0 0 1 2.31 2.13l2.271 27.297a1.94 1.94 0 0 1-1.954 2.117"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2232B",
    d: "M79.325 40.835 64.26 58.974a4.308 4.308 0 0 0 2.402 6.966l24.444 5.284a4.31 4.31 0 0 0 4.914-5.813l-9.372-23.425a4.31 4.31 0 0 0-7.324-1.15M45.792 43.378 40.544 57.52a2.72 2.72 0 0 0 2.817 3.64l15.325-1.503a2.723 2.723 0 0 0 1.862-4.407L50.468 42.62a2.723 2.723 0 0 0-4.676.756",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E35B55",
    d: "m84.521 36.268-14.084 20.44a4.53 4.53 0 0 0 3.136 7.062l25.889 3.446a4.53 4.53 0 0 0 4.659-6.498L92.316 36.822a4.53 4.53 0 0 0-7.795-.554"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M74.186 61.944a2.86 2.86 0 0 1-2.19-1.587 2.52 2.52 0 0 1 .132-2.576l14.12-20.502a2.37 2.37 0 0 1 2.322-.986 2.86 2.86 0 0 1 2.19 1.588l11.827 23.954a2.517 2.517 0 0 1-.132 2.576 2.38 2.38 0 0 1-2.321.988z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E35B55",
    d: "m87.369 43.54 1.649.218a2.12 2.12 0 0 1 1.823 2.156l-.112 2.15a2 2 0 0 1-.026.233l-1.173 6.482a1.744 1.744 0 0 1-1.99 1.4 2.13 2.13 0 0 1-1.823-1.924l-.474-6.697a2 2 0 0 1 0-.233l.11-2.153a1.74 1.74 0 0 1 2.016-1.632m-.132 14.437.448.058a1.9 1.9 0 0 1 1.632 1.93 1.56 1.56 0 0 1-1.806 1.47l-.448-.062a1.896 1.896 0 0 1-1.632-1.926 1.557 1.557 0 0 1 1.806-1.47M51.207 39.393 47.34 54.057a2.722 2.722 0 0 0 3.156 3.36l15-2.926a2.721 2.721 0 0 0 1.453-4.53L55.826 38.213a2.724 2.724 0 0 0-4.62 1.179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50.465 56.235a1.66 1.66 0 0 1-1.518-.51 1.63 1.63 0 0 1-.42-1.534l3.875-14.703a1.4 1.4 0 0 1 1.098-1.022 1.66 1.66 0 0 1 1.517.512l11.161 11.76a1.63 1.63 0 0 1 .423 1.535 1.4 1.4 0 0 1-1.097 1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E35B55",
    d: "m54.228 42.94.955-.187a1.265 1.265 0 0 1 1.422.916l.342 1.28q.02.07.03.142l.608 4.03a1.045 1.045 0 0 1-.84 1.206 1.26 1.26 0 0 1-1.377-.778l-1.552-3.83a1 1 0 0 1-.047-.138l-.353-1.282a1.053 1.053 0 0 1 .812-1.358m2.702 8.479.26-.05a1.12 1.12 0 0 1 1.274.817.94.94 0 0 1-.716 1.204l-.26.05a1.12 1.12 0 0 1-1.275-.814.943.943 0 0 1 .717-1.207"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warning-rafiki-1_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h140v110H0z"
  })))));
};
export default SvgWarningRafiki1;